import cx from 'classnames'
import { BaseActivityEvent } from './BaseActivityEvent'
import { Actor } from './Actor'
import { ActivityEventPosition, WorkflowStatusUpdatedEvent } from './Types'
import { PropertyValuePill } from 'components/PropertyValuePill/PropertyValuePill'
import Styles from './WorkflowStatusUpdated.module.scss'

interface Props extends ActivityEventPosition {
  event: WorkflowStatusUpdatedEvent
}

const WorkflowStatusUpdated = ({ event, ...props }: Props) => {
  const { user, data } = event

  return (
    <BaseActivityEvent
      {...props}
      leftRailClassName={cx(Styles.leftRail, props.isLast && Styles.last)}
      icon={
        <div>
          <div className={Styles.icon}>
            <div className={Styles.dot} />
            {!props.isLast && (
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" className={Styles.arrow}>
                <path d="M0.902123 8L9.09788 8C9.49059 8 9.73002 7.56802 9.52188 7.235L5.424 0.678398C5.22817 0.365064 4.77183 0.365065 4.576 0.678399L0.478124 7.235C0.269984 7.56803 0.509406 8 0.902123 8Z" />
              </svg>
            )}
          </div>
        </div>
      }
      timestamp={event.timestamp}
      content={
        <div className={Styles.content}>
          <PropertyValuePill
            propertyValue={{ value: data.next_status_name, meta: { color: data.next_status_color } }}
          />
        </div>
      }
      nestedContent={
        <div className={Styles.nestedContent}>
          <Actor capitalizeFirstLetter displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> changed
          the status from <span className={Styles.statusName}>{data.prev_status_name}</span> to{' '}
          <span className={Styles.statusName}>{data.next_status_name}</span>
        </div>
      }
    />
  )
}

export { WorkflowStatusUpdated }
